import data from "../../.sourceflow/rewards_incentives.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const rewards_helper = new CollectionHelper(data);
